module.exports = __webpack_public_path__ + "static/media/C017.4e31507e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C017.jpg
// module id = 300
// module chunks = 0